export default "<object width=\"100%\" height=\"100%\" [data]=\"pdfUrl\" type=\"application/pdf\">\r\n  <div>\r\n      Alt Text!\r\n  </div>\r\n</object>"